<template>
  <div class="train-list">
    <div v-for="(list, index) in trainLists" :key="index" class="list-body">
      <div class="buttons">
        <a
          class="button"
          :class="{ disabled: !list.is_available }"
          @click="list.is_available ? goToNextPage(index) : null"
        >
          <div class="row">
            <div
              class="img"
              :class="{
                vse: list.cars_formation.name.substr(0, 3) == 'VSE',
                mse: list.cars_formation.name.substr(0, 3) == 'MSE',
                gse: list.cars_formation.name.substr(0, 3) == 'GSE',
                exe: list.cars_formation.name.substr(0, 3) == 'EXE',
              }"
            ></div>
          </div>
          <div class="row" style="flex-grow: 2">
            <div class="name-icon-row">
              <div class="name">
                {{ list.train.name }}({{ list.cars_formation.name }})
              </div>
              <div class="icons">
                <img
                  v-if="hasChildCareType(list)"
                  :src="require(`@/assets/img/icon/png/child_care_icon.png`)"
                  class="icon"
                />
                <img
                  v-if="hasOtherExclusiveType(list)"
                  :src="require(`@/assets/img/icon/png/dummy_icon.png`)"
                  class="icon"
                />
              </div>
            </div>
            <div class="row">
              <div class="group">
                <div class="section">{{ list.from_station.name }}</div>
                <div class="time">
                  {{ displayMfittTime(list.departure_at) }}
                </div>
              </div>
              <div class="arrow"></div>
              <div class="group">
                <div class="section">{{ list.to_station.name }}</div>
                <div class="time">{{ displayMfittTime(list.arrival_at) }}</div>
              </div>
            </div>
            <MFITTSeatVacant
              seat-name="一般席"
              :count="list.common_vacant_seat_count"
            />
            <MFITTSeatVacant
              seat-name="前展望席"
              :count="list.foreground_vacant_seat_count"
            />
            <MFITTSeatVacant
              seat-name="後展望席"
              :count="list.background_vacant_seat_count"
            />
            <MFITTSeatVacant
              seat-name="サルーン"
              :count="list.saloon_vacant_seat_count"
            />
          </div>
          <div class="row">
            <img
              :src="require(`@/assets/img/icon/png/angle-right.png`)"
              class="angle-right-arrow"
            />
          </div>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";
import { useStore } from "vuex";
import { useRoute, useRouter } from "vue-router";
import {
  hasOtherExclusiveType,
  getOtherExclusiveTypeName,
} from "@/utils/seatUtils";

export default {
  name: "MFITTTrainList",
  props: {
    trainLists: {
      type: Object,
      required: true,
    },
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const router = useRouter();

    const goToNextPage = (index) => {
      router.push({
        name: "MfittBooking3",
        params: { id: index },
        query: {
          coupon_id: route.query.coupon_id,
          changing_limited_express_ticket_id:
            route.query.changing_limited_express_ticket_id,
        },
      });
    };

    // 子育て応援席があるかどうかを判定（exclusive_type = 'A'）
    const hasChildCareType = (list) => {
      if (!list.cars_formation?.cars) return false;

      return list.cars_formation.cars.some((car) => car.exclusive_type === "A");
    };
    return {
      goToNextPage,
      hasChildCareType,
      hasOtherExclusiveType,
      getOtherExclusiveTypeName,
    };
  },
};
</script>

<style lang="scss" scoped>
.train-list {
  width: 100%;
  height: auto;
  margin-bottom: 10px;
}

.train-list .list-body {
  width: 100%;
}

.train-list .list-body .buttons {
}

.train-list .list-body .buttons .button {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1px;
  background-color: #fff;
  padding: 15px 0 8px 15px;
  font-size: 14px;
  color: var(--defaultButtonTextColor);
  text-decoration: none;
  border-bottom: 1px solid #e0e0e0;
}

.train-list .list-body .buttons .disabled {
  background-color: #f2f2f2;
  color: #6e6e6e;
}

.train-list .list-body .buttons .button .row {
  align-self: center;
}

.train-list .list-body .buttons .button .row i {
  font-size: 28px;
}

.train-list .list-body .buttons .button .name {
  display: block;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 14px;
}

.train-list .list-body .buttons .button .row .row {
  display: flex;
  align-self: center;
  margin-left: 6px;
}

.train-list .list-body .buttons .button .row .row .group .section {
  display: block;
  font-size: 15px;
  line-height: 15px;
  font-weight: bold;
  margin-bottom: 4px;
}

.train-list .list-body .buttons .button .row .row .group .time {
  display: block;
  font-size: 18px;
  line-height: 18px;
  font-weight: bold;
  margin-bottom: 6px;
}

.train-list .list-body .buttons .button .row .row .arrow {
  margin: 0 6px;
  background-image: url("~@/assets/img/icon/svg/icon-side-arrow.svg");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 10px;
  width: 30px;
  height: 30px;
}

.train-list .row .angle-right-arrow {
  width: auto;
  height: 16px;
  padding-right: 20px;
}

.train-list .list-body .buttons .button .img {
  background-position: top;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 5px;
  width: 54px;
  height: 54px;
  padding: 0;
  margin: 4px 10px 0 0;
}

/* 車型ごとに画像を使い分け */
.train-list .list-body .buttons .button .vse {
  background-image: url("~@/assets/img/material/btn_sentaku_vse_f3.jpg");
}

.train-list .list-body .buttons .button .mse {
  background-image: url("~@/assets/img/material/btn_sentaku_mse_f3.jpg");
}

.train-list .list-body .buttons .button .gse {
  background-image: url("~@/assets/img/material/btn_sentaku_gse_f3.jpg");
}

.train-list .list-body .buttons .button .exe {
  background-image: url("~@/assets/img/material/btn_sentaku_exe_f3.jpg");
}

.train-list .list-body .buttons .button .name-icon-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.train-list .list-body .buttons .button .name {
  display: block;
  font-size: 15px;
  font-weight: bold;
  margin-bottom: 0;
}

.train-list .list-body .buttons .button .icons {
  display: flex;
  gap: 4px;
}

.train-list .list-body .buttons .button .icon {
  width: 28px;
  height: 28px;
}
</style>
